import React, { Component } from 'react';
import { connect } from 'react-redux';
import { selectSchool } from '../actions';

class PrevNext extends Component {
  constructor(props) {
    super(props);
    this.chart = props.chart;
    this.schools = props.schools;
    this.state = { selected: null };
  }

  next(e) {
    if (e) e.stopPropagation();
    let selectedIndex = 0;
    if (this.state.selected === null) {
      selectedIndex = 0;
    } else {
      selectedIndex =
        this.state.selected + 1 < this.schools.length
          ? this.state.selected + 1
          : 0;
    }
    this.setState({ selected: selectedIndex });
    this.select(selectedIndex);
  }

  prev(e) {
    if (e) e.stopPropagation();
    let selectedIndex = 0;
    if (this.state.selected === null) {
      selectedIndex = this.schools.length - 1;
    } else {
      selectedIndex =
        this.state.selected - 1 >= 0
          ? this.state.selected - 1
          : this.schools.length - 1;
    }
    this.setState({ selected: selectedIndex });
    this.select(selectedIndex);
  }

  select(selectedIndex) {
    this.props.selectSchool({
      [this.chart]: {
        selectedSchool: this.schools[selectedIndex],
        showTooltip: true,
      },
    });
  }

  render() {
    const { selectedSchool } = this.props;
    return (
      <div className="prev-next">
        <button
          dialogCall="select previous school"
          onClick={this.prev.bind(this)}
        >
          <span className="a11y">highlight previous school</span>
          <img className="chev-left" alt="" src="/img/chevron-left-blue.svg" />
        </button>
        <p className="highlight-school">
          {selectedSchool ? selectedSchool.name : 'Highlight school'}
        </p>
        <button dialogCall="select next school" onClick={this.next.bind(this)}>
          <span className="a11y">highlight next school</span>
          <img
            className="chev-right"
            alt=""
            src="/img/chevron-right-blue.svg"
          />
        </button>
      </div>
    );
  }
}

const mapStateToProps = (state, props) => {
  return {
    selectedSchool: state.ui[props.chart]
      ? state.ui[props.chart].selectedSchool
      : null,
  };
};

const mapDispatchToProps = dispatch => ({
  selectSchool: p => dispatch(selectSchool(p)),
});

export default connect(mapStateToProps, mapDispatchToProps)(PrevNext);



// WEBPACK FOOTER //
// ./src/components/prev-next.js